import { createSlice } from '@reduxjs/toolkit';

import endPoints from '../api/endpoint';
import store from './store';
import { deleteApiCall, getApiCall } from '../api/methods';
import { notify } from '../Utils/toastify';
import { MyDocumentState } from '../types';
import { convertToQueryParams } from '../Utils/helperFns';
import { setCommonDataLoader } from './commonSlice';

const initialState: MyDocumentState = {
  myDocumentData: [],
  myDocumentLoading: false,
  myDocumentError: '',
  recentDocumet: [],
  productionDocuments: [],
  recentLoader: false,
  productionList: {},
  setList: {},
  episodeList: {},
  locationList: {},
  departmentList: {},
  filterEpisodes: [],
  filterSets: [],
  filterLocations: [],
  filterDepartments: [],
};
const myDocumentSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setMyDocuments: (state, action) => {
      const { payload }: any = action;
      state.myDocumentData = payload;
    },
    setMyDocumentLoader: (state, action) => {
      const { payload }: any = action;
      state.myDocumentLoading = payload;
    },
    setMyDocumentError: (state, action) => {
      const { payload }: any = action;
      state.myDocumentError = payload;
    },
    setRecentDocument: (state, action) => {
      const { payload }: any = action;
      state.recentDocumet = payload;
    },
    setProductionDocument: (state, action) => {
      const { payload }: any = action;
      state.productionDocuments = payload;
    },
    setRecentLoader: (state, action) => {
      const { payload }: any = action;
      state.recentLoader = payload;
    },
    setProductionList: (state, action) => {
      const { payload }: any = action;
      state.productionList = payload;
    },
    setSetList: (state, action) => {
      const { payload }: any = action;
      state.setList = payload;
    },
    setEpisodeList: (state, action) => {
      const { payload }: any = action;
      state.episodeList = payload;
    },
    setLocationList: (state, action) => {
      const { payload }: any = action;
      state.locationList = payload;
    },
    setDepartmentList: (state, action) => {
      const { payload }: any = action;
      state.departmentList = payload;
    },
    setFilterEpisodes: (state, action) => {
      const { payload }: any = action;
      state.filterEpisodes = payload;
    },
    setFilterSets: (state, action) => {
      const { payload }: any = action;
      state.filterSets = payload;
    },
    setFilterLocations: (state, action) => {
      const { payload }: any = action;
      state.filterLocations = payload;
    },
    setFilterDepartments: (state, action) => {
      const { payload }: any = action;
      state.filterDepartments = payload;
    },
  },
});

export const {
  setMyDocuments,
  setMyDocumentLoader,
  setMyDocumentError,
  setRecentDocument,
  setRecentLoader,
  setDepartmentList,
  setEpisodeList,
  setLocationList,
  setProductionList,
  setSetList,
  setFilterEpisodes,
  setFilterSets,
  setFilterLocations,
  setFilterDepartments,
  setProductionDocument,
} = myDocumentSlice.actions;

export default myDocumentSlice.reducer;

export type MyDocumentEntityScope = {
  entityType?: string;
  entityId?: string;
};

export const getMyDocuments = (
  limit?: number,
  page?: number,
  entityScope?: MyDocumentEntityScope,
) => {
  const { dispatch } = store;
  const scopeQuery = convertToQueryParams({
    entityType: entityScope?.entityType,
    entityId: entityScope?.entityId,
  });
  const endpoint = `${
    endPoints.myDocuments.myDocumentsList
  }?page=${page}&limit=${limit}${scopeQuery ? `&${scopeQuery}` : ''}`;
  dispatch(setMyDocumentLoader(true)); // Show loader before the API call
  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setMyDocuments(data.data)); // Set the production details
        dispatch(setMyDocumentLoader(false)); // Hide loader after successful response
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setMyDocumentLoader(false)); // Hide loader after error
    },
  );
};
export const getRecentDocuments = (
  limit?: number,
  page?: number,
  searchKey?: string,
  episodeIds?: string,
  setIds?: string,
  locationIds?: string,
  departmentIds?: string,
  productionId?: string,
  entityScope?: MyDocumentEntityScope,
) => {
  const { dispatch } = store;
  const query = convertToQueryParams({
    searchKey,
    episodeIds,
    setIds,
    locationIds,
    departmentIds,
    productionId,
    entityType: entityScope?.entityType,
    entityId: entityScope?.entityId,
  });
  // Add limit only if it's defined
  // if (limit !== undefined && limit !== null) {
  //   query.limit = limit;
  // }

  const endpoint = `${
    endPoints.myDocuments.recentDocument
  }?page=${page}&${query}${limit ? `&limit=${limit}` : ''}`;

  dispatch(setRecentLoader(true)); // Show loader before the API call
  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setRecentDocument(data.data));
        dispatch(setRecentLoader(false)); // Hide loader after successful response
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setRecentLoader(false)); // Hide loader after error
    },
  );
};

export const getProductionList = () => {
  const { dispatch } = store;
  const endpoint = endPoints.production.productionNameList;

  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setProductionList(data.data)); // Set the production details
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};
export const getLocationList = (
  productionId?: string,
  epsiodeId?: string,
  setId?: string,
) => {
  const { dispatch } = store;
  let endpoint = endPoints.myDocuments.locationList;
  if (productionId) {
    endpoint += `?productionId=${productionId}`;
  }
  if (epsiodeId) {
    endpoint += `&episodeId=${epsiodeId}`;
  }
  if (setId) {
    endpoint += `&setId=${setId}`;
  }
  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setLocationList(data.data));
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};
export const getSetList = (productionId?: string, epsiodeId?: string) => {
  const { dispatch } = store;
  let endpoint = endPoints.myDocuments.setlist;
  if (productionId) {
    endpoint += `?productionId=${productionId}`;
  }
  if (epsiodeId) {
    endpoint += `&episodeId=${epsiodeId}`;
  }

  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setSetList(data.data));
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};
export const getEpisodeList = (productionId?: any) => {
  const { dispatch } = store;
  let endpoint = endPoints.myDocuments.episodelist;
  if (productionId) {
    endpoint += `?productionId=${productionId}`;
  }

  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setEpisodeList(data.data));
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};
export const getDepartmentList = (entityId: string, enityType: string) => {
  const { dispatch } = store;
  const endpoint = `${endPoints.production.departmentList}?entityType=${enityType}&entityId=${entityId}`;

  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setDepartmentList(data.data));
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};

export const getFilterListByEntity = (
  page: number,
  entityType: string,
  setHasMore?: (hasMore: boolean) => void,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  // Construct the API endpoint with pagination parameters
  const apiendpoint = `${endPoints.myDocuments.filterList}?page=${page}&entityType=${entityType}`;

  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      if (data.data) {
        const currentData = data.data.data;
        // Determine if there is more data
        if (setHasMore) {
          const hasMore = currentData.length === 10; // If less than 10, no more data
          setHasMore(hasMore);
        }
        if (entityType === 'episodes') {
          dispatch(setFilterEpisodes(data.data.data));
        } else if (entityType === 'sets') {
          dispatch(setFilterSets(data.data.data));
        } else if (entityType === 'locations') {
          dispatch(setFilterLocations(data.data.data));
        } else if (entityType === 'departments') {
          dispatch(setFilterDepartments(data.data.data));
        }
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
      // dispatch(setLoading(false))
    },
  );
};
export const deleteDocument = (
  enityType: string | any,
  entityId: any,
  documentId?: any,
  deptId?: any,
  cb?: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  deleteApiCall(
    `${endPoints.myDocuments.deleteDocument}/${enityType}/${entityId}/${documentId}/${deptId}`,
    {},
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
        dispatch(setCommonDataLoader(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setCommonDataLoader(false));
      }
    },
  );
};

export const getProductionDocumentsList = (
  limit?: number,
  page?: number,
  searchKey?: string,
  episodeIds?: string,
  setIds?: string,
  locationIds?: string,
  departmentIds?: string,
  productionId?: string,
  entityId?: string,
  entityType?: string,
  folderType?: string,
  productionIds?: string
) => {
  const { dispatch } = store;

 
  const query =
    folderType === 'studio'
      ? convertToQueryParams({
          searchKey,
          episodeIds,
          setIds,
          locationIds,
          departmentIds,
          entityId,
          entityType,
          productionId
        })
      : convertToQueryParams({
          searchKey,
          episodeIds,
          setIds,
          locationIds,
          departmentIds,
          productionId,
          productionIds
        });
  // Add limit only if it's defined
  // if (limit !== undefined && limit !== null) {
  //   query.limit = limit;
  // }

  const endpoint = `${
    endPoints.myDocuments.myDocumentDeptWise
  }?page=${page}&${query}${limit ? `&limit=${limit}` : ''}`;

  dispatch(setRecentLoader(true)); // Show loader before the API call
  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setProductionDocument(data.data));
        dispatch(setRecentLoader(false)); // Hide loader after successful response
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setRecentLoader(false)); // Hide loader after error
    },
  );
};
